import React from 'react'
import { CompositeDonut, SubjectDonuts, } from './'

export default function DonutCharts({studentScore, subtests}) {
  return (
    <section className="DonutChartContainer">
      <CompositeDonut 
        studentScore={studentScore}
        subtests={subtests}
      />
      <SubjectDonuts 
        studentScore={studentScore}
        subtests={subtests}
      />
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentReport/DonutCharts.js